var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "virtual-pin-input" }, [
    _c("div", { staticClass: "pin-display" }, [
      _c("label", { staticClass: "pin-label" }, [_vm._v(_vm._s(_vm.label))]),
      _c("div", { staticClass: "pin-input-container" }, [
        _c("input", {
          staticClass: "pin-input",
          attrs: {
            type: _vm.showPin ? "text" : "password",
            readonly: "",
            placeholder: _vm.placeholder,
          },
          domProps: { value: _vm.inputText },
        }),
        _c(
          "button",
          {
            staticClass: "toggle-visibility",
            on: {
              click: function ($event) {
                _vm.showPin = !_vm.showPin
              },
            },
          },
          [_vm._v(" " + _vm._s(_vm.showPin ? "🙈" : "👁️") + " ")]
        ),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "pin-grid" },
      _vm._l(_vm.pinRows, function (row, rowIndex) {
        return _c(
          "div",
          { key: rowIndex, staticClass: "pin-row" },
          _vm._l(row, function (key) {
            return _c(
              "button",
              {
                key: key,
                class: [
                  "pin-key",
                  {
                    "pin-backspace": key === "⌫",
                    "pin-clear": key === "C",
                    "pin-submit": key === "OK",
                    "pin-empty": key === "",
                  },
                ],
                attrs: { disabled: _vm.isKeyDisabled(key) },
                on: {
                  click: function ($event) {
                    return _vm.handleKeyClick(key)
                  },
                },
              },
              [_vm._v(" " + _vm._s(key) + " ")]
            )
          }),
          0
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }